import { sitioConfig } from "@/sitio";
import { POST, queryClient } from "@/state/server";
import { useLocation, useRouter } from "@tanstack/react-router";
import { useState } from "react";

const titles = {
  select: "Login",
  login: "Login",
  register: "Register",
  recover: "Recover your password",
} as const;

type Props = {
  external_login: boolean;
  require_password: boolean;
  register: boolean;
  admin?: boolean;
};

function Login({ external_login, require_password, register, admin }: Props) {
  const location = useLocation();

  const [status, setStatus] = useState<
    "select" | "register" | "recover" | "login"
  >(external_login ? "select" : "login");
  const [error, setError] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");

  const router = useRouter();

  async function login() {
    if (admin) {
      const res = await POST("/admin/login", { email, pass });
      if ("error" in res) {
        setError(res.error);
      } else {
        queryClient.invalidateQueries({ queryKey: ["/admin.json"] });
        router.navigate({ to: "/admin", replace: true });
      }
    } else {
      const res = await POST("/login", {
        action: status,
        name,
        email,
        pass,
        pass2,
      });
      if ("error" in res) {
        setError(res.error);
      } else {
        if (location.pathname === "/login") {
          const _global = globalThis as any;
          const { afterLogin } = _global;
          if (afterLogin && typeof afterLogin === "function") {
            _global.afterLogin = undefined;
            afterLogin();
          }

          router.history.back();
        } else router.invalidate();
      }
    }
  }

  return (
    <div className="container">
      <div className="row">
        {/* col-md-offset-4 es la clase de bootstrap 3 (offset-4 es de la 5, que
            no esta cargada). Abajo de 992px la columna ocupa todo el ancho y el
            offset no aplica, en vez de empujar el cuadro fuera de la pantalla. */}
        <div
          className="col-md-4 col-md-offset-4 dialog login"
          style={{
            background: "#fff",
            border: "1px solid #000",
            borderRadius: 6,
            padding: 15,
            textAlign: "center",
          }}
        >
          <h4 style={{ color: "#333" }}>{titles[status]}</h4>
          {error && <div className="alert-danger">{error}</div>}
          {status == "select" && external_login ? (
            <div>
              <div className="social">
                <a
                  id="google_login"
                  className="btn btn-google"
                  href="/auth/google_oauth2"
                >
                  <i className="fa fa-google-plus fa-fw" /> Login con Google
                </a>
                <a
                  id="password_login"
                  className="btn btn-password"
                  onClick={() => setStatus("login")}
                >
                  Login con email
                </a>
              </div>
              <div className="division" />
            </div>
          ) : null}
          {register && status == "register" ? (
            <input
              className="form-control"
              placeholder="Name"
              required={true}
              onChange={(e) => setName(e.target.value)}
            />
          ) : null}

          {!external_login || status != "select" ? (
            <input
              className="form-control"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          ) : null}

          {require_password && status != "select" && status != "recover" ? (
            <input
              className="form-control"
              type="password"
              placeholder="Password"
              onChange={(e) => setPass(e.target.value)}
            />
          ) : null}
          {register && require_password && status == "register" ? (
            <input
              className="form-control"
              type="password"
              placeholder="Password Confirmation"
              onChange={(e) => setPass2(e.target.value)}
            />
          ) : null}
          {status != "select" ? (
            <button
              className="btn btn-default btn-login"
              onClick={() => login()}
            >
              {titles[status]}
            </button>
          ) : null}
          {register && status == "login" ? (
            <span className="modal-footer">
              <button
                className="btn btn-warning btn-login"
                onClick={() => setStatus("register")}
              >
                Register
              </button>
              {require_password && (
                <span>
                  {" "}
                  &nbsp;-&nbsp;
                  <a onClick={() => setStatus("recover")}>
                    Don't remember your password?
                  </a>
                </span>
              )}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export function UserLogin() {
  const { local } = sitioConfig;
  return (
    <Login
      external_login={!local}
      require_password={!local}
      register={true}
    ></Login>
  );
}

export function AdminLogin() {
  return (
    <Login
      external_login={false}
      require_password={true}
      register={false}
      admin={true}
    ></Login>
  );
}
